import type { Actions } from "..";
import groupBy from "./groupBy";
import utils from "./utils";

export default (actions: Actions) => ({
  ...utils(actions),
  ...groupBy(actions),
});
